export default __webpack_public_path__ + "static/media/bossMaterial.e565a29c.png";